import * as React from "react"
import { SVGProps } from "react"
const PickupIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={29.698} height={34} {...props}>
    <g
      fill="none"
      stroke="#2c3e50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      data-name="Component 6467 \u2013 6"
    >
      <path
        d="M9.656 14.848a5.193 5.193 0 1 0 5.193-5.193 5.193 5.193 0 0 0-5.193 5.193"
        data-name="Path 5892"
      />
      <path
        d="M24.642 24.642 17.3 31.987a3.462 3.462 0 0 1-4.894 0l-7.35-7.345a13.849 13.849 0 1 1 19.586 0Z"
        data-name="Path 5893"
      />
    </g>
  </svg>
)
export default PickupIcon
